import apiClient from "./Api";

/**
 * Obtiene todas las capas de un grupo de capas.
 * @param {string} layerGroupUuid
 */
export const updateGridStatus = async (grid_uuid, new_status) => {
  // Endpoint swagger: GET /gis/layers/by_layers_group/{layer_group_uuid}
  const response = await apiClient.post(
    `/layers/tools/grid/update_status/${grid_uuid}/${new_status}`
  );
  return response.data;
};
/**
 * Regenera la cuadrícula desde una capa con FormData.
 * @param {string} project_uuid
 * @param {string} grid_uuid
 * @param {string} layer_uuid
 * @param {number} size
 * @param {string} layer_name_en
 * @param {string} layer_name_es
 */
export const regenerateGrid = async ({
  project_uuid,
  grid_uuid,
  layer_uuid,
  size,
  layer_name_en,
  layer_name_es,
}) => {
  try {
    const formData = new FormData();
    formData.append("layer_name_en", layer_name_en);
    formData.append("layer_name_es", layer_name_es);

    if (size) {
      formData.append("size_x", size);
      formData.append("size_y", size);
    }

    // Realizar la solicitud con FormData
    const response = await apiClient.post(
      `layers/tools/update_grid_from_layer/${project_uuid}/${grid_uuid}/${layer_uuid}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error regenerando la cuadrícula:", error);
    throw error;
  }
};
